var locationMap = function() {

	var options,
		el,
		imageMarker,
		marker,
		map;

	var _init = function(latLng, assetsDir) {
		options = {
			zoom: 15,
			scrollwheel: false,
			center: new google.maps.LatLng(52.382835, 4.920456),
			styles: [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#000000"},{"lightness":-25},{"saturation":-97}]}]
		};

		imageMarker = {
			url: '/content/themes/emerceeday/assets/img/icon-marker.svg'
		};

		el = document.getElementById('edayLocation');
		map = new google.maps.Map(el, options);

		marker = new google.maps.Marker({
			position: new google.maps.LatLng(52.382835, 4.920456),
			map: map,
			icon: imageMarker
		});
	};

	return {
		init: _init
	};

}();

if (document.getElementById('edayLocation')) {
	locationMap.init(wp_vars.lat_lng, wp_vars.assets_dir);
}



// WEBPACK FOOTER //
// ./resources/assets/js/partials/LocationMap.js